import { render } from "./IconNews.vue?vue&type=template&id=227bcca2&lang=html"
import script from "./IconNews.vue?vue&type=script&lang=js"
export * from "./IconNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__